<template>
  <div class="notice-page">
    <!-- 顶部导航栏 -->
    <nav class="top-navigation">
      <div class="nav-tabs">
        <div v-for="(tab, index) in tabList" :key="tab.id" class="nav-tab" :class="{ active: activeTab === index }"
          @click="switchTab(tab, index)">
          {{ tab.name }}
        </div>
      </div>
    </nav>
    <!-- 筛选区域 -->
    <section class="filter-section">
      <!-- 公告类型筛选 -->
      <div class="filter-group">
        <div class="filter-label">公告类型</div>
        <div class="filter-options">
          <div v-for="type in announcementTypes" :key="type.value" class="filter-option"
            :class="{ active: selectedAnnouncementType === type.value }" @click="selectAnnouncementType(type.value)">
            {{ type.label }}
          </div>
        </div>
      </div>
      <!-- 项目地区筛选 -->
      <div class="filter-group">
        <div class="filter-label">项目地区</div>
        <div class="filter-options">
          <div v-for="region in visibleRegions" :key="region.value" class="filter-option"
            :class="{ active: selectedRegion === region.value }" @click="selectRegion(region)">
            {{ region.label }}
          </div>
          <div class="filter-option expand-btn" @click="toggleRegionExpand">
            {{ isRegionExpanded ? '收起' : '展开' }}
            <img class="expand-arrow" :class="{ rotated: isRegionExpanded }" src="@/assets/image/new_slices/expand.png"
              alt="展开">
          </div>
        </div>
      </div>
    </section>
    <!-- 公告列表 -->
    <div class="announcement-table">
      <header class="table-header">
        <div class="header-cell announcement-name-header">公告名称</div>
        <div class="header-cell notice-nature-header">公告性质</div>
        <div class="header-cell release-time-header">发布时间</div>
      </header>
      <div class="table-body" v-if="announcements.length != 0">
        <div v-for="(item, index) in announcements" :key="`announcement-${index}`" class="table-row"
          @click="details(item)">
          <div class="cell announcement-name">
            <span class="region-info">
              {{ item.projectLocationProvince }}
            </span>
            <span class="announcement-title">{{ item.noticeName }}</span>
          </div>
          <div class="cell notice-nature">
            <span class="nature-tag" :class="item.noticeNature === 2 ? 'nature-change' : 'nature-normal'">{{ item.noticeNature === 2 ? '变更公告' : '正常公告' }}</span>
          </div>
          <div class="cell release-time">{{ extractDateFromString(item.noticeSendTime) }}</div>
        </div>
      </div>
      <div v-else style=" margin: auto;">
        <el-empty description="暂无数据"></el-empty>
      </div>
      <div class="view-more" v-if="announcements.length != 0">
        <span class="more-link" @click="moreClick">查看更多</span>
        <img class="more-image" src="@/assets/image/new_slices/more.png">
      </div>
    </div>
  </div>
</template>

<script>
import areaData from 'china-area-data'

// 常量定义
const TAB_LIST = [
  { id: '1', name: '企业采购' },
  { id: '2', name: '政府采购' },
  { id: '3', name: '建设工程' }
];

const ANNOUNCEMENT_TYPES = [
  { value: '1', label: '招标公告' },
  { value: '2', label: '中标公告' },
  { value: '3', label: '中标候选人公示' },
  { value: '4', label: '澄清公告' },
  
  
];


export default {
  name: 'NoticeArea',
  props: {
    announcements: {
      type: Array,
      default: () => ([])
    },
    noticeType: {
      type: [String, Number],
      default: '1'
    }
  },
  mounted() {
    this.initAreaData()
    // 初始化时同步 noticeType
    this.selectedAnnouncementType = String(this.noticeType)
  },
  data() {
    return {
      areaData: areaData,
      // 当前激活的标签页
      activeTab: 0,
      // 地区展开状态
      isRegionExpanded: false,
      // 选中的地区(存储value)
      selectedRegion: '',
      // 选中的公告类型
      selectedAnnouncementType: '1',
      // 标签页列表
      tabList: TAB_LIST,
      // 公告类型列表
      announcementTypes: ANNOUNCEMENT_TYPES,
      // 所有地区列表
      allRegions: [],
    }

  },
  computed: {
    // 可见的地区列表（根据展开状态决定显示数量）
    visibleRegions() {
      return this.isRegionExpanded ? this.allRegions : this.allRegions.slice(0, 15);
    }
  },
  watch: {
    // 监听父组件传入的 noticeType 变化
    noticeType: {
      handler(newVal) {
        this.selectedAnnouncementType = String(newVal)
      },
      immediate: true
    }
  },
  methods: {
    details(item) {
      //  打开新页面
      window.open('/homeDetail?noticeCode=' + item.noticeCode + '&noticeType=' + this.selectedAnnouncementType, '_blank')
    },
    //  更多
    moreClick() {
     this.$router.replace('/deal')

    },

    // 初始化地区数据
    initAreaData() {
      try {
        // 获取省份数据 (中国的省份数据在 '86' 下)
        const provinces = this.areaData['86'];
        const arr = Object.keys(provinces).map(code => ({
          label: provinces[code],
          value: code
        }));
        // 添加"全部"选项
        this.allRegions = [{ label: '全部', value: '' }, ...arr];
      } catch (error) {
        console.error('初始化地区数据失败:', error);
      }
    },
    /**
     * 切换标签页
     */
    switchTab(tab, index) {
      this.activeTab = index;
      this.$emit('property-change', tab.id);
    },

    /**
     * 切换地区展开/收起状态
     */
    toggleRegionExpand() {
      this.isRegionExpanded = !this.isRegionExpanded;
    },
    selectRegion(region) {
      this.selectedRegion = region.value;
      // 向父组件发送选中的地区value
      this.$emit('region-change', region.value);
    },
    selectAnnouncementType(type) {
      this.$emit('noticeType', type);
      this.selectedAnnouncementType = type;
    },
    extractDateFromString(input) {
      if (!input) return '-';
      const dateMatch = input.match(/\d{4}-\d{2}-\d{2}/);
      return dateMatch ? dateMatch[0] : '-';
    }

  }
}
</script>

<style scoped>
/* ===== 基础布局 ===== */
.notice-page {
  width: 100%;
  background: #f5f5f5;
  margin-top: 20px;
}

/* ===== 顶部导航栏 ===== */
.top-navigation {
  background: #fff;
  border-bottom: 1px solid #D8D8D8;
}

.nav-tabs {
  display: flex;
  align-items: center;
  height: 56px;
}

.nav-tab {
  width: 187px;
  height: 56px;
  line-height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  border-right: 1px solid #D8D8D8;

}

.nav-tab.active {
  color: #ffffff;
  background-color: #005EEC;
  border-bottom: none;
}

.nav-tab:hover:not(.active) {
  color: #005EEC;
}

/* ===== 筛选区域 ===== */
.filter-section {
  background: #fff;
  padding-top: 38px;
  padding-left: 36px;
  box-sizing: border-box;
  padding-right: 36px;
  padding-bottom: 33px;
}

.filter-group {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.filter-group:last-child {
  margin-bottom: 0;
}

.filter-label {
  font-size: 14px;
  color: #656668;
  white-space: nowrap;
  width: 56px;
  padding-top: 6px;
  margin-right: 65px;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}

.filter-option {
  padding: 4px 13px;
  border: 1px solid transparent;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  color: #000;
  cursor: pointer;
  background: #fff;
}

.filter-option.active,
.filter-option:hover {
  border-color: #005EEC;
  color: #005EEC;
}

.expand-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  border-color: #ddd;
  font-size: 14px;
  color: #656668;
}

.expand-btn:hover {
  color: #666;
  border-color: #ddd;
}

.expand-arrow {
  width: 12px;
  height: 12px;
  transition: transform 0.3s ease;
}

.expand-arrow.rotated {
  transform: rotate(180deg);
}

/* ===== 公告列表 ===== */
.announcement-table {
  background: #fff;
  overflow: hidden;
}

.table-header {
  display: flex;
  text-align: start;
  gap: 10px;
  padding: 0 20px;
}

.header-cell {
  background: #F7F8FA;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  margin-left: 10px;
  color: #656668;
  font-family: PingFang SC, PingFang SC;
}

/* 表头列宽定义 */
.announcement-name-header {
  flex: 1;
  padding-left: 10px;
}

.procurement-method-header {
  width: 150px;
  margin: 0 10px;
}

.notice-nature-header {
  width: 120px;
  text-align: center;
  padding-left: 10px;
}

.release-time-header {
  width: 103px;
  height: 40px;
  padding: 0px;
  text-align: center;
  background: #F7F8FA;
}

.table-body {
  max-height: 600px;
  overflow-y: auto;

}


.table-row {
  display: flex;
  text-align: start;
  gap: 10px;
  padding: 0 20px;
}

.table-row:hover {
  background: #fafafa;
}

.cell {
  padding: 16px 20px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
}

/* 表格列布局 */
.announcement-name {
  flex: 1;
  text-align: start;
  line-height: 1.5;
  cursor: pointer;
  transition: color 0.3s ease;

}


.region-info {
  width: 130px;
  min-width: 130px;
  color: #005EEC;
  margin-right: 8px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.region-image {
  width: 12px;
  height: 12px;
}

.region-info i {
  margin-right: 5px;
}

.announcement-title {
  flex: 1;
  color: black;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #272829;
}

.announcement-title:hover {
  color: #005EEC;
}

.procurement-method {
  width: 150px;
  margin: 0 10px;
  justify-content: center;
}

.notice-nature {
  width: 120px;
  justify-content: center;
}

.nature-tag {
  padding: 2px 10px;
  border-radius: 3px;
  font-size: 12px;
}

.nature-normal {
  color: #00A26C;
  background: rgba(0, 162, 108, 0.1);
}

.nature-change {
  color: #E6A23C;
  background: rgba(230, 162, 60, 0.1);
}

.release-time {
  width: 103px;
  padding: 0px;
  color: #000;
  font-size: 14px;
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

/* ===== 方法标签样式 ===== */
.method-tag {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  color: #00A26C;
  border: 1px dotted #00A26C;
  background: transparent;
}

/* 统一所有方法标签样式 */
.method-tag.inquiry,
.method-tag.competitive-consultation,
.method-tag.competitive-negotiation,
.method-tag.public-bidding {
  color: #00A26C;
  border: 1px dotted #00A26C;
  background: transparent;
}

/* ===== 查看更多 ===== */
.view-more {
  height: 56px;
  text-align: center;
  justify-content: center;
  line-height: 56px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #D8D8D8;
}

.more-link {
  color: #005EEC;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.more-image {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
}

.more-link:hover {
  color: #40a9ff;
}
</style>
